import { render, staticRenderFns } from "./TakeOrders.vue?vue&type=template&id=4f9b1ac0"
import script from "./TakeOrders.vue?vue&type=script&lang=js"
export * from "./TakeOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports